export const load = () => ({
	title: 'How to Order Indow Window Inserts',
	showTitle: true,
});
